import React from 'react';
import { Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { closeUpdateRequiredModal } from 'actions/onlineStore';
import styles from './UpdateRequiredModal.css';

class UpdateRequiredModal extends React.Component {
  render() {
    const { showUpdateRequiredModal } = this.props;

    return (
      <Modal
        show={showUpdateRequiredModal}
        backdrop="static"
        keyboard={false}
        className={styles['update-required-modal']}
        dialogClassName={styles['update-required-modal-dialog']}
      >
        <Modal.Header>
          <Modal.Title>Update Required</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          In order to use GoStore, please update your business name by editing
          your Business Info under Account Settings.
        </Modal.Body>
        <Modal.Footer>
          <button
            className={`btn btn-default ${styles['btn-action']}`}
            type="button"
            onClick={this._handleHide}
          >
            Cancel
          </button>
          <button
            className={`btn btn-primary ${styles['btn-action']}`}
            type="button"
            onClick={this._handleUpdate}
          >
            Update
          </button>
        </Modal.Footer>
      </Modal>
    );
  }

  _handleHide = () => {
    this.props.dispatch(closeUpdateRequiredModal());
  };

  _handleUpdate = () => {
    window.location.href = '/settings/accounts';
  };
}

function mapStateToProps(state) {
  const { shop } = state.onlineStore;

  return {
    showUpdateRequiredModal: shop.showUpdateRequiredModal,
  };
}

function mapDispatchToProps(dispatch) {
  return { dispatch };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(UpdateRequiredModal);
